import { KeyboardEvent } from "react";

export const preventEnterEvent = (e: KeyboardEvent<HTMLButtonElement>) => {
  e.key === "Enter" && e.preventDefault();
};
